import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.link";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _slicedToArray from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isShowQmAdv ? _c('XytAdv', {
    attrs: {
      "advName": "adv1",
      "posIds": "efb23bc4",
      "options": {
        location: {
          page_position: '22'
        }
      },
      "reportExt": {
        vip: _vm.isVip,
        level: _vm.vipLevel
      }
    },
    scopedSlots: _vm._u([{
      key: "adv",
      fn: function fn(_ref) {
        var _ref$advInfo = _slicedToArray(_ref.advInfo, 1),
          adv = _ref$advInfo[0];
        return [adv ? _c('div', {
          staticClass: "qm_adv_container adv_container mask",
          on: {
            "touchmove": function touchmove($event) {
              $event.preventDefault();
            }
          }
        }, [_c('div', {
          staticClass: "img-view adv_report",
          attrs: {
            "ad-param": JSON.stringify(_objectSpread(_objectSpread({}, adv), {}, {
              f_resource: adv['material_info'].pic,
              f_module: '福利社弹层'
            }))
          }
        }, [_c('img', {
          attrs: {
            "src": adv.material_info.pic
          }
        }), _c('div', {
          staticClass: "qm_adv_report",
          on: {
            "click": function click($event) {
              _vm.openUrl(adv.material_info.link);
              _vm.isShowQmAdv = false;
            }
          }
        }), _c('div', {
          staticClass: "close_box adv_report_close",
          on: {
            "click": function click($event) {
              _vm.isShowQmAdv = false;
            }
          }
        })])]) : _vm._e()];
      }
    }], null, false, 872403943)
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };